export default __webpack_public_path__ + "static/media/shared-earth-merch-image.e9fb63ca.jpg";